document.addEventListener('DOMContentLoaded', function () {
  // Galerie fiche produit : clic sur une vignette -> change l'image principale
  document.querySelectorAll('[data-nx-gallery-main]').forEach(function (main) {
    var img = main.querySelector('img');
    if (!img) return;
    document.querySelectorAll('[data-nx-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        // image_tag generates a srcset, which browsers prefer over src —
        // it has to be cleared or the swapped src is silently ignored.
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = thumb.getAttribute('data-full-src');
        document.querySelectorAll('[data-nx-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });

  // Sélecteur de quantité
  document.querySelectorAll('[data-nx-qty-input]').forEach(function (input) {
    var wrap = input.closest('.nx-qty');
    var decrease = wrap.querySelector('[data-nx-qty-decrease]');
    var increase = wrap.querySelector('[data-nx-qty-increase]');
    if (decrease) decrease.addEventListener('click', function () {
      var next = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      input.value = next;
    });
    if (increase) increase.addEventListener('click', function () {
      input.value = (parseInt(input.value, 10) || 1) + 1;
    });
  });

  // Sélecteur de variante (fiche produit)
  var productForm = document.getElementById('NxProductForm');
  if (productForm && window.NxProductVariants) {
    var selectors = productForm.querySelectorAll('[data-nx-option-selector]');
    var variantIdInput = productForm.querySelector('[data-nx-variant-id]');
    var submitButton = productForm.querySelector('[data-nx-add-to-cart]');
    function currentSelection() {
      var values = [];
      selectors.forEach(function (select) {
        values[parseInt(select.getAttribute('data-position'), 10) - 1] = select.value;
      });
      return values;
    }
    function findMatchingVariant() {
      var values = currentSelection();
      return window.NxProductVariants.find(function (variant) {
        return values.every(function (value, index) { return variant.options[index] === value; });
      });
    }
    selectors.forEach(function (select) {
      select.addEventListener('change', function () {
        var variant = findMatchingVariant();
        if (!variant) return;
        variantIdInput.value = variant.id;
        if (submitButton) submitButton.disabled = !variant.available;
      });
    });
  }

  document.querySelectorAll('[data-nx-reviews]').forEach(function (block) {
    var track = block.querySelector('[data-nx-reviews-track]');
    var prev = block.querySelector('[data-nx-reviews-prev]');
    var next = block.querySelector('[data-nx-reviews-next]');
    if (!track) return;
    function step() {
      var card = track.querySelector('.nx-review-card');
      return card ? card.offsetWidth + 12 : 240;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  });
});
